import { buildStoreUrl } from './storeCampaign';

export const addUtmParams = (url, utmParams, utmMedium) => {
    if (!url) return url;

    const storedOthers = getStoredOtherParams() || {};

    const finalUtms = hasExternalUtmParams()
        ? getStoredUtmParams()
        : { ...utmParams, ...(utmMedium ? { medium: utmMedium } : {}) };

    // Store links need a `referrer` wrapper or pt/ct, not an appended query.
    const storeUrl = buildStoreUrl(url, finalUtms, storedOthers);
    if (storeUrl) return storeUrl;

    const params = new URLSearchParams();
    Object.entries(finalUtms).forEach(([key, value]) => {
        if (value) params.append(`utm_${key}`, value);
    });
    Object.entries(storedOthers).forEach(([key, value]) => {
        params.append(key, value);
    });

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${params.toString()}`;
};


export const initializeUtmStorage = () => {
    if (typeof window === 'undefined') return;

    const alreadyInitialized =
        sessionStorage.getItem('external_utm_params') !== null ||
        sessionStorage.getItem('external_other_params') !== null;

    if (alreadyInitialized) return;

    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {};
    const otherParams = {};
    let hasUtm = false;
    let hasOther = false;

    urlParams.forEach((value, key) => {
        if (key.startsWith('utm_')) {
            utmParams[key.replace('utm_', '')] = value;
            hasUtm = true;
        } else {
            otherParams[key] = value;
            hasOther = true;
        }
    });

    const utmSource = urlParams.get('utm_source');

    if (hasUtm && utmSource !== 'gtaf-website') {
        sessionStorage.setItem('external_utm_params', JSON.stringify(utmParams));
    }

    if (hasOther) {
        sessionStorage.setItem('external_other_params', JSON.stringify(otherParams));
    }
};


export const getStoredUtmParams = () => {
    if (typeof window === 'undefined') return null;

    const stored = sessionStorage.getItem('external_utm_params');
    return stored ? JSON.parse(stored) : null;
};


export const getStoredOtherParams = () => {
    if (typeof window === 'undefined') return null;

    const stored = sessionStorage.getItem('external_other_params');
    return stored ? JSON.parse(stored) : null;
};


export const hasExternalUtmParams = () => {
    return getStoredUtmParams() !== null;
};


export const hasExternalOtherParams = () => {
    return getStoredOtherParams() !== null;
};


export const getUtmMediumFromAppRoute = (appRoute) => {
    switch (appRoute) {
        case 'hisnul':
            return 'dua-en';
        case 'hisnulbn':
            return 'dua-bn';
        case 'quiz':
            return 'deen-quiz';
        default:
            return appRoute;
    }
};
